import { render, staticRenderFns } from "./MinxinScroll.vue?vue&type=template&id=7db43903&scoped=true&"
import script from "./MinxinScroll.vue?vue&type=script&lang=js&"
export * from "./MinxinScroll.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7db43903",
  null
  
)

export default component.exports